// extracted by mini-css-extract-plugin
module.exports = {"container":"Board_container__tK2eZ"};